<template>
    <div class="product_wrapper category_wrapper" :class="lang">
        <div class="page-head">
            <div class="container" v-if="product">
                    <router-link to="/">{{ lang == 'en' ? 'Home' : 'الرئيسية' }}</router-link> <i :class="lang == 'en' ? 'fa-solid fa-chevron-right' : 'fa-solid fa-chevron-left'"></i><router-link :to="`/physical-store/${replaceSpaces(product.sub_category.name.toLowerCase())}/${product.sub_category.id}`"> {{ product.sub_category.name }} </router-link> <i :class="lang == 'en' ? 'fa-solid fa-chevron-right' : 'fa-solid fa-chevron-left'"></i> <span class="prod-name">{{ product.name.split(' ').length > 4 ? product.name.split(' ').slice(0, 4).join(' ') + ' ...' : product.name }}
                        <div class="hint-pop-up" v-if="product && product.name.split(' ').length > 4">{{ product.name }}</div>
                </span>
            </div>
        </div>
        <div class="container" v-if="product">
            <div class="head">
                <div class="cat">
                    <img src="./../assets/imgs/tag.svg" alt="tag icon">
                    <h4>{{product.sub_category.name}}</h4>
                </div>
                <div class="right">
                    <div>
                        <a href="" :class="product.isFav ? 'active' : ''" class="add-to-wish" @click.prevent="likeProduct(product.id, 1)"><i class="fa-regular fa-heart"></i> <p>{{ product_data.add_to_wishlist }}</p></a>
                    </div>
                    <div>
                        <p>{{ product_data.share }}</p>
                        <a :href="`https://www.facebook.com/sharer/sharer.php?u=${this.url}`" target="_blank">
                            <i class="fa-brands fa-facebook-f"></i>
                        </a>
                        <a href="/" @click.prevent="shareOnInstagram()">
                            <i class="fa-brands fa-instagram"></i>
                        </a>
                        <a :href="`https://twitter.com/intent/tweet?url=${this.url}&text=${this.caption}`" target="_blank">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="#8897b7" height=".85em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg>
                        </a>

                    </div>
                </div>
            </div>

            <div class="body">
                <div>
                    <div class="imgs">
                        <div class="side">
                            <div class="img" v-for="(item, index) in product.images" :key="item.id" @click="setCurrentImage(item.img, index)">
                                <img :src="item.img" alt="product image">
                            </div>
                        </div>
                        <div class="main_img">
                            <!-- <img :src="product.main_image" alt="product main image"> -->
                            <div class="main-image" ref="mainImage" :style="{ backgroundImage: `url(${currentImage})` }" @mousemove="zoomImage" @mouseenter="startZoom" @mouseleave="endZoom" @click="openModal(currentIndex)"></div>
                            <img src="./../assets/imgs/shipping_abroad.png" alt="shipping abroad" class="shipping_icon" v-if="product.shipping_abroad">
                        </div>
                    </div>
                    <div class="content">
                        <div class="top">
                            <h1>{{ product.name }}</h1>
                            <div class="rate">
                                <div class="stars">
                                    <i v-for="(star, index) in getStars(product.reviews_avg_rating)" :key="index" :class="star"></i>
                                </div>
                                ( {{ product.reviews_count }} {{ product_data.reviews }} )
                                <span class="write-review" v-if="user != null && !product.user_has_reviewed && product.user_has_purchased" @click="openDialog">{{lang == 'en' ? 'Rate Product' : 'تقييم المنتج ' }}</span>
                                <span class="write-review" v-if="user != null && product.user_has_reviewed && product.user_has_purchased" @click="openDialog">{{lang == 'en' ? 'Edit Rating' : 'تعديل التقييم' }}</span>
                            </div>
                            <a href="/compare" @click.prevent="addProductToCompare(product)" class="" style="display: flex;align-items: center;gap: 10px;margin-bottom:10px;text-decoration: none;color: #0471ad;"><i class="fa-solid fa-arrow-right-arrow-left"></i><span>{{ lang == "ar" ? "اضافة الي المقارنة" : "Add to Compare" }}</span></a>
                            <div class="price">
                                <h1 v-if="product.price_after_discount">{{ product.price_after_discount ? product.price_after_discount.toLocaleString() : '' }} <span>{{ product_data.egp }}</span></h1>
                                <h1><span>{{ product.price.toLocaleString() }}</span> <span>{{ product_data.egp }}</span></h1>
                            </div>
                            <p class="stock" :class="product.type == 0 ? 'in' : (isProductInStock(product) ? 'managed' : 'out')">{{ product.type == 0 ? (lang == 'en' ? "In Stock" : "متاح")  : (isProductInStock(product) ? (lang == 'en' ? "Limited Stock" : "كمية محدودة") : (lang == 'en' ? "Out Of Stock" : "نفذت الكمية")) }}</p>

                        <div class="saved" v-if="product.price_after_discount"><i class="fa-regular fa-bookmark"></i> {{ product_data.saved }}: {{  (product.price - product.price_after_discount).toLocaleString() }} {{ product_data.egp }}</div>
                        </div>

                        <div class="bottom">
                            <div class="quantity">
                                {{ product_data.quantity }}
                                <span>
                                    <span @click="this.quantity > 1 ? this.quantity -= 1 : ''">-</span>
                                    <span>{{ quantity }}</span>
                                    <span @click="this.quantity += 1">+</span>
                                </span>
                            </div>
                            <!-- <button :class="{ 'disable-add-to-cart': !isProductInStock(product)}" :disabled="!isProductInStock(product)" @click="buyNow(product, quantity)"><i class="fa-solid fa-credit-card"></i>{{ lang == 'en' ? "  Buy Now" : "اشتري الآن " }}</button> -->
                            
                            <button :class="{'disable-add-to-cart': !isProductInStock(product)}" @click="addProductToCart(product, quantity, product.stock, product.type)"><i class="fa-solid fa-cart-shopping"></i> {{ product_data.add_cart }}</button>
                        </div>
                    </div>
                </div>
                <div class="side">
                    <div class="ad" onclick="window.location.href='/build-pc'" style="cursor: pointer;">
                        <img src="./../assets/imgs/hero-card-1.jpg" alt="main image">
                        <!-- <a href="/build-pc">{{ product_data.shop_now }}</a> -->
                        <h1>{{ product_data.build_pc }}</h1>
                    </div>
                    <div class="features">
                        <div>
                            <i class="fa-solid fa-rotate-left"></i>
                            <div>
                                <h4>{{ product_data.free_returns }}</h4>
                                <p>{{ product_data.free_returns_text }}</p>
                            </div>
                        </div>
                        <div class="ml-n1">
                            <i class="fa-solid fa-truck-fast"></i>
                            <div>
                                <h4>{{ product_data.trusted_shipping }}</h4>
                                <p>{{ product_data.trusted_shipping_text }}</p>
                            </div>
                        </div>
                        <div>
                            <i class="fa-solid fa-shield-halved"></i>
                            <div>
                                <h4>{{ product_data.secure_shoping }}</h4>
                                <p>{{ product_data.secure_shoping_text }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="details">
                <div class="header">
                    <a href="" :class="show_speci ? 'active' : ''" @click.prevent="this.show_speci = true; this.show_desc = false; this.show_rev = false; this.show_support = false">{{ product_data.specification }}</a>
                    <a href="" :class="show_desc ? 'active' : ''"  @click.prevent="this.show_speci = false; this.show_desc = true; this.show_rev = false; this.show_support = false">{{ product_data.descreption }}</a>
                    <a href="" :class="show_rev ? 'active' : ''"   @click.prevent="this.show_speci = false; this.show_desc = false; this.show_rev = true; this.show_support = false">{{ product_data.reviews }}</a>
                    <a href="" :class="show_support ? 'active' : ''"   @click.prevent="this.show_speci = false; this.show_desc = false; this.show_rev = false; this.show_support = true">{{ product_data.support }}</a>
                </div>
                <div class="body">
                    <div class="table" v-if="show_speci">
                        <template  v-if="product && product.specifications.length > 0">
                            <div class="row" v-for="spsi in product.specifications" :key="spsi.id">
                            <div class="title">{{ spsi.key }}</div>
                            <div class="value">{{ spsi.value }}</div>
                        </div>
                        </template>
                        <template v-else>
                            {{ product_data.no_specifications_available }}
                        </template>
                    </div>
                    <!-- description -->
                    <div class="desc" v-if="show_desc">
                        <template v-if="product.desc && product.desc != ''">
                            <div v-html="product.desc"></div>
                            <!-- <ul>
                            <li v-for="(text, index) in formatDescription(product.desc)" :key="index" v-html="text"></li>
                        </ul> -->
                        </template>
                        <template v-else>
                            {{ product_data.no_description_available }}
                        </template>
                    </div>
                    <!-- reviews detail -->
                    <div class="users-reviews" v-if="show_rev">
                        <ReviewComponent v-if="product.reviews.length" :reviewsList="product.reviews"/>
                        <template v-else>
                            {{ product_data.no_reviews_yet }}
                        </template>
                    </div>
                    <!-- support -->
                    <div v-if="show_support">
                        <div v-if="product.support" v-html="product.support"></div>
                        <div v-else>{{ product_data.no_support_available }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container products" v-if="related_products && related_products.length > 0">
            <h1>{{ product_data.related }}</h1>
            <div class="body">
                <div class="product" v-for="item in related_products" :key="item.id">
                    <router-link :to="`/product/${item.id}/${replaceSpaces(item.name)}`">
                        <div class="img">
                            <img :src="item.main_image" :alt="item.name" class="prod-img">
                            <p>{{ item.sub_category.name }}</p>
                            <h4 class="prod-name">
                                {{ item.name.length >= 39 ? item.name.slice(0, 39) + '...' :  item.name }}
                                <div class="hint-pop-up" v-if="item && item.name.length > 39">{{ item.name }}</div>
                            </h4>
                        </div>
                        <div>
                            <div class="rate">
                                <div class="stars">
                                    <i v-for="(star, index) in getStars(item.reviews_avg_rating)" :key="index" :class="star"></i>
                                </div>
                                ( {{ item.reviews_count }} {{ product_data.reviews }} )
                            </div>
                            <div class="price">
                                <h1 v-if="item.price_after_discount">{{ item.price_after_discount ? item.price_after_discount.toLocaleString() : '' }}</h1>
                                <h1>{{ item.price.toLocaleString() }}</h1>
                            </div>
                        </div>
                    </router-link>
                    <!-- <button class="buy-now" :class="{ 'disable-button': !isProductInStock(item)}" :disabled="!isProductInStock(item)" @click="buyNow(item, 1, item.stock, item.type)">
                        {{ lang == 'en' ? "Buy Now" : "اشتري الآن" }}
                    </button> -->
                    <button class="add-to-cart"  :class="{ 'out-of-stock-prod': !isProductInStock(item)}" @click="addProductToCart(item, 1)">
                        {{ !isProductInStock(item) ? (lang == 'en' ? "Out Of Stock" : "نفذت الكمية") : product_data.add_cart }}
                    </button>
                    <button :class="item.isFav ? 'active' : ''" class="add-to-wishlist" @click="likeProduct(item.id)">
                        <i class="fa-regular fa-heart"></i> {{ product_data.add_to_wishlist }}
                    </button>
                </div>
            </div>
            <div class="pagination" v-if="last_page > 1">
                <div v-for="page_num in last_page" :key="page_num" >
                    <label :for="`page_num_${page_num}`" :class="page_num == page ? 'active' : ''">{{ page_num }}</label>
                    <input type="radio" name="page_num" :id="`page_num_${page_num}`" v-model="page" :value="page_num" @change="fetchProduct(productId)">
                </div>
            </div>
        </div>
        <WidgetContainerModal />
        <div class="image-modal" v-if="isModalOpen" @click.self="closeModal">
            <div class="modal-header">
            <div class="icon-buttons">
                <button class="close-icon" @click="closeModal">
                <i class="fa-solid fa-times"></i>
                </button>
                <button class="zoom-icon" @click="toggleZoom">
                <i :class="isZoomed ? 'fa-solid fa-search-minus' : 'fa-solid fa-search-plus'"></i>
                </button>
            </div>
            <div class="counter">{{ currentIndex + 1 }} / {{ product.images.length }}</div>
            </div>
            <div class="modal-body" ref="modalBody">
            <button class="prev-button" @click="prevImage">
                <i class="fa-solid fa-chevron-left"></i>
            </button>
            <img
                :src="product.images[currentIndex].img"
                alt="Product Image"
                class="modal-img"
                :style="{
                transform: isZoomed ? `scale(2) translate(${translateX}px, ${translateY}px)` : 'scale(1)',
                cursor: modalImgCursor,
                touchAction: 'none'
                }"
                @click="toggleZoom"
                @mousedown="startDrag"
                @mousemove="dragImage"
                @mouseup="endDrag"
                @mouseleave="endDrag"
                @touchstart="startDrag"
                @touchmove="dragImage"
                @touchend="endDrag"
                @load="loadImageDimensions"
            />
            <button class="next-button" @click="nextImage">
                <i class="fa-solid fa-chevron-right"></i>
            </button>
            </div>
        </div>
    </div>
</template>

<script>
const API_URL = process.env.VUE_APP_API_URL
global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;
// import { router } from 'vue';
import axios from 'axios';
import ReviewComponent from '@/components/ReviewComponent.vue';
import ReviewModal from '@/components/ReviewModal.vue'
import {container, openModal} from "jenesius-vue-modal";
// import { Magnifier } from 'vue3-zoomer';
export default {
    name: 'ProductView',
    data() {
        return {
            url: window.location.href,
            caption: this.product ? this.product.name : '',
            show_speci: true,
            show_desc: false,
            show_rev: false,
            show_support: false,
            productId: this.$route.params.id,
            product: null,
            quantity: 1,
            currentImage: null,
            related_products: [],
            per_page: 8,
            page: 1,
            total: 0,
            last_page: 0,
            cart: null,
            products: null,
            cards: null,
            lang: 'en',
            product_data: null,
            user: null,
            naturalWidth: 0,
            naturalHeight: 0,
            zoomFactor: 1.6,
            imageLoaded: false,
            isModalOpen: false,
            currentIndex: 0,
            isZoomed: false,
            dragging: false,
            startX: 0,
            startY: 0,
            translateX: 0,
            translateY: 0,
            modalImgCursor: 'default',
        }
    },
    components:{
        ReviewComponent,
        WidgetContainerModal: container,
        // Magnifier,
    },
    methods: {
        formatDescription(text){
            if (!text) {
                return []
            }
            // Split the text into sentences using line breaks
            let sentences = text.split(/\n/);
            // filter out empty lines
            return sentences.filter(sent => sent.trim())
        },

        setLangCookies() {
            let langCheck = document.cookie.indexOf('lang')

            this.is_cookies = langCheck >= 0 ? true : false

            function getCookie(cname) {
                let name = cname + "=";
                let decodedCookie = decodeURIComponent(document.cookie);
                let ca = decodedCookie.split(';');
                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            } // to get an cookie by name ##############################

            if (langCheck !== -1) {
                this.lang = getCookie('lang') // check lang cookie exist ##############################
            }

            if (sessionStorage.getItem("lang"))
                this.lang = sessionStorage.getItem("lang") // check lang session exist ##############################

            sessionStorage.setItem("lang", this.lang); // set lang session ##############################

            let searchParams = new URLSearchParams(window.location.search)
            if (searchParams.has('lang')) {
                this.lang = searchParams.get('lang')
                document.body.classList.add(searchParams.get('lang')) // add lang class ##############################
            } else {
                document.body.classList.add(this.lang) // add lang class ##############################
            }

        },
        shareOnInstagram() {
            var pageUrl = window.location.href;
            var instagramUrl = "https://www.instagram.com/share?url=" + encodeURIComponent(pageUrl);
            window.open(instagramUrl, "_blank");
        },
        async getCart() {
            $('.loader').fadeIn().css('display', 'flex')
            try {
                const response = await axios.get(`${API_URL}/users/cart`,
                    {
                        headers: {
                            "AUTHORIZATION": 'Bearer ' + sessionStorage.getItem('user_token'),
                            "lang": this.lang
                        },
                    }
                );
                if (response.data.status === true) {
                    $('.loader').fadeOut()
                    this.products = response.data.data.products

                    for (let i = 0; i < this.products.length; i++) {
                        this.products[i].product_type = 1;
                    }
                    this.cards = response.data.data.cards
                    for (let i = 0; i < this.cards.length; i++) {
                        this.cards[i].product_type = 2;
                    }
                    this.cart = this.products.concat(this.cards)
                }

            } catch (error) {
                console.error(error);
            }
        },
        async fetchProduct(productId) {
            $('.loader').fadeIn().css('display', 'flex')
            try {
                const response = await axios.get(`${API_URL}/products/getProductDetails?product_id=${productId}&per_page=${this.per_page}&page=${this.page}`, {
                    headers: {
                        "AUTHORIZATION": 'Bearer ' + sessionStorage.getItem('user_token'),
                        "lang": this.lang
                    }
                });
                if (response.data.status === true) {
                    this.product = response.data.data.product
                    this.currentImage = this.product.main_image;
                    this.related_products = response.data.data.related_products.products
                    this.total = response.data.data.related_products.total
                    this.last_page = response.data.data.related_products.last_page
                    if (!this.products || !this.products[0])
                        this.showNotProducts = true
                    $('.loader').fadeOut()
                    setTimeout(() => {
                        $('#errors').fadeOut('slow')
                    }, 4000);
                } else {
                    $('.loader').fadeOut()
                    document.getElementById('errors').innerHTML = ''
                    $.each(response.data.errors, function (key, value) {
                        let error = document.createElement('div')
                        error.classList = 'error'
                        error.innerHTML = value
                        document.getElementById('errors').append(error)
                    });
                    $('#errors').fadeIn('slow')
                    setTimeout(() => {
                        $('input').css('outline', 'none')
                        $('#errors').fadeOut('slow')
                    }, 3500);
                }

            } catch (error) {
                document.getElementById('errors').innerHTML = ''
                let err = document.createElement('div')
                err.classList = 'error'
                err.innerHTML = 'server error try again later'
                document.getElementById('errors').append(err)
                $('#errors').fadeIn('slow')
                $('.loader').fadeOut()

                setTimeout(() => {
                    $('#errors').fadeOut('slow')
                }, 3500);

                console.error(error);
            }
        },
        async likeProduct(product_id) {
            try {
                const response = await axios.post(`${API_URL}/products/${product_id}/liked`, {
                },
                    {
                        headers: {
                            "AUTHORIZATION": 'Bearer ' + sessionStorage.getItem('user_token'),
                            "lang": this.lang
                        }
                    },
                );
                if (response.data.status === true) {
                    document.getElementById('errors').innerHTML = ''
                    this.fetchProduct(this.productId)
                    $('.loader').fadeOut()
                } else {
                    $('.loader').fadeOut()
                    document.getElementById('errors').innerHTML = ''
                    $.each(response.data.errors, function (key, value) {
                        let error = document.createElement('div')
                        error.classList = 'error'
                        error.innerHTML = value
                        document.getElementById('errors').append(error)
                    });
                    $('#errors').fadeIn('slow')

                    setTimeout(() => {
                        $('input').css('outline', 'none')
                        $('#errors').fadeOut('slow')
                    }, 3500);
                }

            } catch (error) {
                document.getElementById('errors').innerHTML = ''
                let err = document.createElement('div')
                err.classList = 'error'
                err.innerHTML = 'server error try again later'
                document.getElementById('errors').append(err)
                $('#errors').fadeIn('slow')
                $('.loader').fadeOut()

                setTimeout(() => {
                    $('#errors').fadeOut('slow')
                }, 3500);

                console.error(error);
            }
        },
        async buyNow(product, qty, product_valid_qty, product_stock) {
            if (!this.isProductInStock(product)) {
                return;
            }
            if (product_stock == 2) {
                document.getElementById('errors').innerHTML = '';
                let error = document.createElement('div');
                error.classList = 'error';
                error.innerHTML = 'This product is not available now';
                document.getElementById('errors').append(error);
                $('#errors').fadeIn('slow');
                setTimeout(() => {
                    $('input').css('outline', 'none');
                    $('#errors').fadeOut('slow');
                }, 3500);
                return;
            }
            if (product_valid_qty < qty && product_stock == 1) {
                document.getElementById('errors').innerHTML = '';
                let error = document.createElement('div');
                error.classList = 'error';
                error.innerHTML = 'This quantity is not available';
                document.getElementById('errors').append(error);
                $('#errors').fadeIn('slow');
                setTimeout(() => {
                    $('input').css('outline', 'none');
                    $('#errors').fadeOut('slow');
                }, 3500);
                return;
            }
            const token = sessionStorage.getItem('user_token');
            if (!token) {
                document.getElementById('errors').innerHTML = '';
                let error = document.createElement('div');
                error.classList = 'error';
                error.innerHTML = this.lang == 'ar' ? 'يجب عليك تسجيل الدخول أولاً!' : 'You must log in first!';
                document.getElementById('errors').append(error);
                $('#errors').fadeIn('slow');
                setTimeout(() => {
                    $('input').css('outline', 'none');
                    $('#errors').fadeOut('slow');
                    this.$router.push('/login');
                }, 3500);
                return;
            }
            let item = {
                product: product,
                qty: qty,
                type: 'product',
                total_price: product.price_after_discount ? product.price_after_discount * qty : product.price * qty
            };
            sessionStorage.setItem('buyNowItem', JSON.stringify([item]));
            this.$router.push('/checkout?from=buy-now');
        },
        async addProductToCart(product, qty, product_valid_qty, product_stock) {
            if (!this.isProductInStock(product)) {
                return
            }
            if (product_stock == 2) {
                document.getElementById('errors').innerHTML = ''
                let error = document.createElement('div')
                error.classList = 'error'
                error.innerHTML = 'This product is not available now'
                document.getElementById('errors').append(error)
                $('#errors').fadeIn('slow')

                setTimeout(() => {
                    $('input').css('outline', 'none')
                    $('#errors').fadeOut('slow')
                }, 3500);

            } else if (product_valid_qty < qty && product_stock == 1) {
                document.getElementById('errors').innerHTML = ''
                let error = document.createElement('div')
                error.classList = 'error'
                error.innerHTML = 'This quantity is not available'
                document.getElementById('errors').append(error)
                $('#errors').fadeIn('slow')

                setTimeout(() => {
                    $('input').css('outline', 'none')
                    $('#errors').fadeOut('slow')
                }, 3500);
            } else {
                
                // let token = sessionStorage.getItem('user_token')
                // console.log("token: " + token)
                // if(!token){
                //     let item = {
                //         product: product,
                //         qty: qty,
                //     };
                //     // Retrieve cart from sessionStorage
                //     let cart = sessionStorage.getItem('cartItems');
                //     // If cart is null or empty, initialize as an empty array
                //     cart = cart ? JSON.parse(cart) : [];
                //     // Add new item to cart
                //     cart.push(item);
                //     // Save updated cart back to sessionStorage
                //     sessionStorage.setItem('cartItems', JSON.stringify(cart));
                //     console.log("Updated cart:", cart);
                //     return
                // }

                let token = sessionStorage.getItem('user_token');
                console.log("token: " + token);

                if (!token) {
                    let item = {
                        product: product,
                        qty: qty,
                        type:'product'
                    };

                    // Retrieve cart from sessionStorage
                    let cart = sessionStorage.getItem('cartItems');
                    cart = cart ? JSON.parse(cart) : [];

                    // Find the index of the existing item with the same product.id
                    let existingIndex = cart.findIndex(cartItem => cartItem.product.id === item.product.id);

                    if (existingIndex !== -1) {
                        // If item exists, update its quantity
                        cart[existingIndex].qty += item.qty;
                    } else {
                        // If item does not exist, add new item to cart
                        cart.push(item);
                    }

                    // Save updated cart back to sessionStorage
                    sessionStorage.setItem('cartItems', JSON.stringify(cart));
                    console.log("Updated cart:", cart);

                    document.getElementById('errors').innerHTML = ''
                    let error = document.createElement('div')
                    error.classList = 'success'
                    error.innerHTML = "Added to cart"
                    document.getElementById('errors').append(error)
                    $('#errors').fadeIn('slow')
                    setTimeout(() => {
                        $('#errors').fadeOut('slow')
                        $('.loader').fadeOut()
                    }, 1000);
                    return
                }

                $('.loader').fadeIn().css('display', 'flex')
                try {
                    const response = await axios.post(`${API_URL}/products/${product.id}/add-cart`, {
                        qty: qty,
                        type: 'add',
                    },
                        {
                            headers: {
                                "AUTHORIZATION": 'Bearer ' + sessionStorage.getItem('user_token'),
                                "lang": this.lang
                            }
                        },
                    );
                    if (response.data.status === true) {
                        document.getElementById('errors').innerHTML = ''
                        let error = document.createElement('div')
                        error.classList = 'success'
                        error.innerHTML = response.data.message
                        document.getElementById('errors').append(error)
                        $('#errors').fadeIn('slow')
                        setTimeout(() => {
                            $('#errors').fadeOut('slow')
                            $('.loader').fadeOut()
                            if (!this.cart || !this.cart.length) {
                                window.location.reload()
                            }
                        }, 1000);
                    } else {
                        $('.loader').fadeOut()
                        document.getElementById('errors').innerHTML = ''
                            let error = document.createElement('div')
                            error.classList = 'error'
                            error.innerHTML = response.data.errors[0] == "quantity is not available" || response.data.errors[0] == "الكمية المطلوبة غير متوفرة" ? (this.lang == "ar" ? "نفذت الكمية" : "Quantity not avilable") : (this.lang == "ar" ? "يجب عليك تسجيل الدخول اولا" :  "You have to login first!" )
                            document.getElementById('errors').append(error)
                        $('#errors').fadeIn('slow')

                        setTimeout(() => {
                            $('input').css('outline', 'none')
                            $('#errors').fadeOut('slow')
                        }, 3500);
                    }

                } catch (error) {
                    document.getElementById('errors').innerHTML = ''
                    let err = document.createElement('div')
                    err.classList = 'error'
                    err.innerHTML = 'server error try again later'
                    document.getElementById('errors').append(err)
                    $('#errors').fadeIn('slow')
                    $('.loader').fadeOut()

                    setTimeout(() => {
                        $('#errors').fadeOut('slow')
                    }, 3500);

                    console.error(error);
                }
            }
        },
        addProductToCompare(product) {
            $('.loader').fadeIn()
            if (localStorage.getItem('compare_cart')) {
                if (JSON.parse(localStorage.getItem('compare_cart')).length < 3) {
                    let compare = JSON.parse(localStorage.getItem('compare_cart'));
                    let itemExists1 = compare[0] ? compare[0].id == product.id : false
                    let itemExists2 = compare[1] ? compare[1].id == product.id : false
                    let itemExists3 = compare[2] ? compare[2].id == product.id : false
                    if (!itemExists1 && !itemExists2 && !itemExists3) {
                        compare.push(product)
                        localStorage.setItem('compare_cart', JSON.stringify(compare))
                        document.getElementById('errors').innerHTML = ''
                        let error = document.createElement('div')
                        error.classList = 'success'
                        error.innerHTML = this.lang == 'ar' ? 'تمت إضافة المنتج للمقارنة بنجاح' : 'product added to compare successfully'
                        document.getElementById('errors').append(error)
                        $('#errors').fadeIn('slow')
                        setTimeout(() => {
                            $('input').css('outline', 'none')
                            $('#errors').fadeOut('slow')
                            $('.loader').fadeOut()
                        }, 2000);
                    } else {
                        document.getElementById('errors').innerHTML = ''
                        let error = document.createElement('div')
                        error.classList = 'error'
                        error.innerHTML = this.lang == 'ar' ? 'هذا المنتج موجود بالفعل في المقارنة' : 'This product is already in the compare'
                        document.getElementById('errors').append(error)
                        $('#errors').fadeIn('slow')
                        $('input').css('outline', 'none')
                        $('#errors').fadeOut('slow')
                        $('.loader').fadeOut()
                    }
                } else {
                    document.getElementById('errors').innerHTML = ''
                    let error = document.createElement('div')
                    error.classList = 'error'
                    error.innerHTML = this.lang == 'ar' ? 'المقارنة لا يمكن أن تحتوي على أكثر من 3 عناصر' : 'Compare cannot have more than 3 items'
                    document.getElementById('errors').append(error)
                    $('#errors').fadeIn('slow')
                    setTimeout(() => {
                        $('input').css('outline', 'none')
                        $('#errors').fadeOut('slow')
                        $('.loader').fadeOut()
                    }, 2000);
                }
            } else {
                let compare = []
                compare.push(product)
                localStorage.setItem('compare_cart', JSON.stringify(compare))
                document.getElementById('errors').innerHTML = ''
                let error = document.createElement('div')
                error.classList = 'success'
                error.innerHTML = this.lang == 'ar' ? 'تمت إضافة المنتج للمقارنة بنجاح' : 'product added to compare successfully'
                document.getElementById('errors').append(error)
                $('#errors').fadeIn('slow')
                setTimeout(() => {
                    $('input').css('outline', 'none')
                    $('#errors').fadeOut('slow')
                    $('.loader').fadeOut()
                }, 2000);
            }
        },
        getHomeData() {
            this.show_speci = true;
            this.show_desc = false;
            this.show_rev = false;
            window.scrollTo(0, 0);
            this.productId = this.$route.params.id
            this.setLangCookies()
            let data = require('../assets/api/product.json');
            this.product_data = this.lang == 'ar' ? data.ar : data.en
            this.fetchProduct(this.productId)
            this.getCart()
        },
        openDialog(){
            const props = {lang: this.lang, productId: this.product.id, isCard: false, isEditRating: this.product.user_has_reviewed, user_review: this.product.user_review};
            openModal(ReviewModal, props) // Promise<ModalObject>
        },
        setCurrentImage(imgSrc, index) {
            this.currentImage = imgSrc;
            this.currentIndex = index;
            console.log('currentImage updated to:', this.currentImage);
            this.loadImageDimensions(); // Ensure dimensions are loaded
        },

        /** Loads the natural dimensions of the image */
        loadImageDimensions() {
            const img = new Image();
            img.src = this.currentImage;
            img.onload = () => {
                this.naturalWidth = img.naturalWidth;
                this.naturalHeight = img.naturalHeight;
                this.imageLoaded = true;
                console.log('Natural dimensions:', this.naturalWidth, this.naturalHeight);
            };
            img.onerror = () => {
                console.error('Failed to load image:', this.currentImage);
                this.imageLoaded = false;
            };
        },
        startZoom() {
            const container = this.$refs.mainImage;
            if (!container || !this.imageLoaded) {
                console.log('Cannot start zoom: Container or image not ready');
                return;
            }

            const containerWidth = container.offsetWidth;
            const containerHeight = container.offsetHeight;
            const zoomedWidth = this.naturalWidth * this.zoomFactor;
            const zoomedHeight = this.naturalHeight * this.zoomFactor;

            console.log('Container size:', containerWidth, containerHeight);
            console.log('Zoomed size:', zoomedWidth, zoomedHeight);

            if (zoomedWidth > containerWidth && zoomedHeight > containerHeight) {
                container.style.backgroundSize = `${zoomedWidth}px ${zoomedHeight}px`;
            } else {
                console.log('Image too small to zoom');
            }
        },

        /** Resets the image when hover ends */
        endZoom() {
            const container = this.$refs.mainImage;
            if (container) {
                container.style.backgroundSize = 'contain';
                container.style.backgroundPosition = 'center';
            }
        },

        /** Adjusts the zoomed image position based on mouse movement */
        zoomImage(event) {
            const container = this.$refs.mainImage;
            if (!container || !this.imageLoaded) return;

            const rect = container.getBoundingClientRect();
            const mouseX = event.clientX - rect.left;
            const mouseY = event.clientY - rect.top;

            const containerWidth = rect.width;
            const containerHeight = rect.height;
            const zoomedWidth = this.naturalWidth * this.zoomFactor;
            const zoomedHeight = this.naturalHeight * this.zoomFactor;

            if (zoomedWidth <= containerWidth || zoomedHeight <= containerHeight) {
                console.log('Zoom skipped: Image not large enough');
                return;
            }

            const xPercent = mouseX / containerWidth;
            const yPercent = mouseY / containerHeight;

            const bgX = -xPercent * (zoomedWidth - containerWidth);
            const bgY = -yPercent * (zoomedHeight - containerHeight);

            console.log('Zooming at:', mouseX, mouseY, 'Background position:', bgX, bgY);
            container.style.backgroundPosition = `${bgX}px ${bgY}px`;
        },

        // drag
        startDrag(event) {
  if (!this.isZoomed) return;
  this.dragging = true;

  // Handle both mouse and touch events
  const clientX = event.type.includes('touch') ? event.touches[0].clientX : event.clientX;
  const clientY = event.type.includes('touch') ? event.touches[0].clientY : event.clientY;

  this.startX = clientX - this.translateX;
  this.startY = clientY - this.translateY;
  this.modalImgCursor = 'grabbing';
  const img = this.$refs.modalBody.querySelector('.modal-img');
  img.style.transition = 'none'; // Disable transition during drag
  event.preventDefault(); // Prevent default behaviors (scrolling, zooming)
},

dragImage(event) {
  if (!this.dragging || !this.isZoomed) return;

  // Handle both mouse and touch events
  const clientX = event.type.includes('touch') ? event.touches[0].clientX : event.clientX;
  const clientY = event.type.includes('touch') ? event.touches[0].clientY : event.clientY;

  const scale = 2;
  // Adjust movement by scale
  this.translateX = (clientX - this.startX) / scale;
  this.translateY = (clientY - this.startY) / scale;

  const modalBody = this.$refs.modalBody;
  if (!modalBody || !this.imageLoaded) return;

  // Get container and image dimensions
  const containerWidth = modalBody.offsetWidth;
  const containerHeight = modalBody.offsetHeight;
  const scaledWidth = this.naturalWidth * scale;
  const scaledHeight = this.naturalHeight * scale;

  // If image is smaller than container, prevent dragging
  if (scaledWidth <= containerWidth || scaledHeight <= containerHeight) {
    this.translateX = 0;
    this.translateY = 0;
    return;
  }

  // Calculate maximum drag distance
  const maxDragX = (scaledWidth - containerWidth) / (2 * scale);
  const maxDragY = (scaledHeight - containerHeight) / (2 * scale);

  // Limit translation to keep image within bounds
  this.translateX = Math.max(-maxDragX, Math.min(this.translateX, maxDragX));
  this.translateY = Math.max(-maxDragY, Math.min(this.translateY, maxDragY));
},

endDrag() {
  this.dragging = false;
  this.modalImgCursor = this.isZoomed ? 'grab' : 'default';
  const img = this.$refs.modalBody.querySelector('.modal-img');
  img.style.transition = 'transform 0.3s ease'; // Restore transition
},
            toggleZoom() {
            this.isZoomed = !this.isZoomed;
            if (!this.isZoomed) {
              this.translateX = 0;
              this.translateY = 0;
              this.dragging = false;
              this.modalImgCursor = 'default';
            } else {
              this.modalImgCursor = 'grab';
            }
          },
          nextImage() {
            this.currentIndex = (this.currentIndex + 1) % this.product.images.length;
            this.isZoomed = false;
            this.translateX = 0;
            this.translateY = 0;
            this.dragging = false;
            this.modalImgCursor = 'default';
          },
          prevImage() {
            this.currentIndex = (this.currentIndex - 1 + this.product.images.length) % this.product.images.length;
            this.isZoomed = false;
            this.translateX = 0;
            this.translateY = 0;
            this.dragging = false;
            this.modalImgCursor = 'default';
          },
          openModal(index) {
            this.currentIndex = index;
            this.isModalOpen = true;
            this.isZoomed = false;
            this.translateX = 0;
            this.translateY = 0;
            this.dragging = false;
            this.modalImgCursor = 'default';
            document.body.style.overflow = 'hidden';
          },
          closeModal() {
            this.isModalOpen = false;
            this.isZoomed = false;
            this.translateX = 0;
            this.translateY = 0;
            this.dragging = false;
            this.modalImgCursor = 'default';
            document.body.style.overflow = 'auto';
          },
        },
    mounted() {
        this.user = sessionStorage.getItem('user') ? sessionStorage.getItem('user') : null
        $('.add-to-wish').on('click', function () {
            $(this).addClass('active')
        })
        $(document).mousemove(function (e) {
            $('.hint-pop-up').css({
                top: e.clientY,
                left: e.pageX + 10 // Adjust the position to 10px to the right of the mouse
            });
        });
    },
    watch: {
        '$route.params.id': {
            handler: 'getHomeData', // Call the getHomeData method when $route.params.id changes
            immediate: true,       // Call it immediately when the component is created
        },
        product: {
            handler(newProduct) {
                if (newProduct?.name) {
                    // Set the title when product data is loaded
                    document.title = newProduct.name;
                }
            },
            immediate: true
        },
        currentImage() {
            this.imageLoaded = false; // Reset loading status
            this.loadImageDimensions(); // Reload dimensions when image changes
        },
    },
    created() {
        // $(function () {
        //     $(document).on('click', '.side .img', function () {
        //         let src = $(this).find('img').attr('src')
        //         $(this).find('img').attr('src', $('.main_img img').attr('src'))
        //         $('.main_img img').attr('src', src)
        //     })

        //     $(`.physical-store`).addClass('active')
        //     $(`.physical-store`).siblings().removeClass('active')
        // })
        $(function () {
        // Remove this:
        // $(document).on('click', '.side .img', function () {
        //     let src = $(this).find('img').attr('src')
        //     $(this).find('img').attr('src', $('.main_img img').attr('src'))
        //     $('.main_img img').attr('src', src)
        // })
        $(`.physical-store`).addClass('active')
        $(`.physical-store`).siblings().removeClass('active')
        })
        this.getHomeData()
    },
}
</script>

<style scoped>
.quantity {
    justify-content: start;
}

.main_img {
    width: 100%;
    height: 100%; /* Fixed height */
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

.main-image {
    width: 100%;
    height: 100%; /* Fill the parent */
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    overflow: hidden;
}

.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: transparent;
}

.icon-buttons {
  display: flex;
  gap: 20px;
}

.icon-buttons button {
  color: #fff;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
}

.counter {
  font-size: 18px;
  color: #fff;
}

.modal-body {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 10px;
}

/* Style for both Previous and Next buttons */
.prev-button,
.next-button {
  position: absolute;           /* Position buttons relative to the modal-body */
  top: 50%;                    /* Vertically center the buttons */
  transform: translateY(-50%); /* Adjust for perfect centering */
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent background for visibility */
  border: none;                /* Remove default border */
  padding: 10px;               /* Add padding for clickable area */
  font-size: 24px;             /* Larger icon size */
  cursor: pointer;             /* Indicate clickability */
  border-radius: 50%;          /* Circular buttons */
  z-index: 10;                 /* Ensure buttons are above the image */
}

/* Specific positioning for Previous button */
.prev-button {
  left: 0;                     /* Anchor to the left edge */
  padding-left: 10px;          /* Offset from the edge to avoid overlap */
}

/* Specific positioning for Next button */
.next-button {
  right: 0;                    /* Anchor to the right edge */
  padding-right: 10px;         /* Offset from the edge to avoid overlap */
}

.next-button {
  right: 0;
  padding-right: 10px;
}

.modal-img {
  width: 100%;
  max-width: 600px;
  max-height: 80vh;
  /* height: auto; */
  object-fit: contain;
  transition: transform 0.3s ease;
  user-select: none;
  pointer-events: auto;
  touch-action: none;
}

.modal-img[style*="cursor: grab"] {
  cursor: grab;
}

.modal-img[style*="cursor: grabbing"] {
  cursor: grabbing;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
   .modal-img {
    max-width: 95vw; /* Slightly larger on mobile for better dragging */
    max-height: 85vh; /* Allow more vertical space */
  }
  .modal-header {
    padding: 10px; /* Reduce padding on smaller screens */
  }

  .icon-buttons button {
    font-size: 24px; /* Larger icons for better tap targets */
  }

  .counter {
    font-size: 16px; /* Slightly smaller but still readable */
  }

  .modal-body {
    padding: 5px;              /* Reduce padding to maximize space */
  }

  .prev-button,
  .next-button {
    font-size: 30px;           /* Larger icons for touch targets */
    padding: 15px;             /* Larger clickable area */
  }

  .prev-button {
    left: 5px;                 /* Slight inset from edge */
  }

  .next-button {
    right: 5px;                /* Slight inset from edge */
  }
}

@media (max-width: 600px) {
    .product_wrapper .container .body .imgs {
        height: 300px; /* Adjust based on design needs */
    }

    .product_wrapper .container .body .imgs .main_img {
        min-width: 300px;
        width: -moz-min-content;
        width: min-content;
        height: 100%;
    }
}
</style>


<style>
.hint-pop-up {
    position: fixed;
    display: none;
    padding: 10px;
    background-color: #f1f1f1;
    border: 1px solid #ccc;
    z-index: 99999;
    font-size: 12px;
    border-radius: 10px;
}

.prod-name:hover .hint-pop-up {
    display: block;
}

.prod-name {
    position: relative;
    cursor: pointer;
}

.out-of-stock-prod {
    color: #f34135 !important;
    border: 1px solid #f34135 !important;
}

.out-of-stock-prod:hover {
    background: #f34135 !important;
    color: white !important;
}

.disable-add-to-cart {
    background: linear-gradient(270deg, #8bbbd4 0%, #6a7e88 100%) !important;
}

.buy-now{
    background-color: #425a8c;
    color: #fff;
    padding: .5rem;
    font-size: .8rem;
    font-weight: 600;
    border-radius: .3rem;
    text-align: center;
    border: 1px solid #425a8c;
    width: 100%;
    transition: all .3s ease-in;
}

.buy-now:hover{
    background-color: transparent;
    color: #425a8c;
}

.disable-button{
    opacity: 0.5;
    pointer-events: none;
}
</style>